
import _ from 'lodash';
import Bugsnag from '@bugsnag/js';
import parsePotentiallyGroupedFloat from '~/mixins/parse-potentially-grouped-float';

import addCurrency from '~/mixins/addCurrency';

export default {
    mixins: [parsePotentiallyGroupedFloat, addCurrency],
    props: {
        editions: {
            type: Array,
            default: () => [],
        },
        numberOfParticipants: {
            type: Number,
            default: 1
        },
        vatNumber: {
            type: String,
            default: 'NL861164969B01'
        },
        customerCountry: {
            type: String,
            default: null
        },
        customerState: {
            type: String,
            default: null
        },
        customerPostalCode: {
            type: String,
            default: null
        },
        couponCode: {
            type: String,
            default: null
        }
    },
    data() {
        return {
            price: {},
            selectedCurrency: null
        };
    },
    computed: {
        editionsMap() {
            return this.editions.map((edition) => {
                return {
                    editionId: edition.id,
                    participantCount: edition?.participants?.length ?? this.numberOfParticipants,
                    primaryEdition: edition?.primaryEdition ?? false
                };
            });
        }
    },
    watch: {
        numberOfParticipants() {
            this.getEditionPrice();
        },
        vatNumber() {
            this.getEditionPrice();
        },
        customerCountry() {
            this.getEditionPrice();
        },
        customerState() {
            this.getEditionPrice();
        },
        customerPostalCode() {
            this.getEditionPrice();
        },
        couponCode() {
            this.getEditionPrice();
        },
        price() {
            this.$nuxt.$emit('priceUpdate', this.price);
        }
    },
    created() {
        this.getCurrency();
        this.getEditionPrice();
    },
    mounted() {
        this.$nuxt.$on('selectedCurrency', () => {
            this.getEditionPrice();
        });

        this.$root.$on('selectedCurrency', () => {
            this.getEditionPrice();
        });

        this.$nuxt.$emit('priceUpdate', this.price);

        this.$nuxt.$on('priceUpdate', (payload) => {
            this.price = payload;
        });

        this.$root.$on('update-editions', () => {
            this.getEditionPrice();
        });
    },
    methods: {
        getEditionPrice: _.debounce(async function() {
            this.getCurrency();

            const priceVariables = {
                editions: this.editionsMap,
                vatNumber: this.vatNumber,
                customerCountry: this.customerCountry,
                customerState: this.customerState,
                customerPostalCode: this.customerPostalCode,
                currency: this.selectedCurrency,
                couponCode: this.couponCode,
                site: this.$config.appMultisiteHandle
            };

            await this.$axios.post(this.$config.apiUrl + '/api/prices/calculate', priceVariables)
                .then((response) => {
                    this.price = response.data;
                })
                .catch((error) => {
                    console.error(error); // eslint-disable-line no-console

                    Bugsnag.notify(error, (event) => {
                        event.addMetadata('price', {
                            priceVariables
                        });
                    });
                });
        }, 300),

        getCurrency() {
            if (process.client) {
                this.selectedCurrency = localStorage.getItem('selectedCurrency') || 'EUR';
            } else {
                this.selectedCurrency = 'EUR';
            }
        },
    },
};
